import { useState } from "react";
import { BRAND_COLOR } from "../constants";
import { toast } from "react-toastify";
import { useIntl } from "react-intl";

type Props = {
	additionalData?: {
		matchCount?: number;
	};
	noAction?: boolean;
	src: string;
	label?: string;
	handleClick?: () => void;
};

export default function GridPhotoItem({ additionalData, noAction, src, label, handleClick }: Props) {
	const intl = useIntl();
	const [showModal, setShowModal] = useState(false);

	const isMatched = additionalData?.matchCount ? additionalData.matchCount == -1 : false;

	return (
		<>
			<div className="col-4 p-1">
				<div
					className="card position-relative overflow-hidden"
					onClick={() => {
						if (!noAction) {
							handleClick?.();
						} else {
							setShowModal(true);
						}
					}}
					style={{ height: 120, cursor: "pointer" }}
				>
					{/* Match badge */}
					{additionalData?.matchCount ? (
						<span
							className={`badge bg-${
								isMatched ? "success" : "danger"
							} position-absolute top-0 end-0 m-1 py-2`}
							style={{ zIndex: 1 }}
						>
							{isMatched ? (
								<i className="fa-solid fa-check fs-6"></i>
							) : (
								<span>{additionalData.matchCount}</span>
							)}
						</span>
					) : null}

					<img src={src} className="card-img-top h-100 w-100 object-fit-cover" alt="" />

					{/* Gradient Overlay with Label */}
					{label ? (
						<div
							className="position-absolute bottom-0 start-0 w-100 px-2 py-1"
							style={{
								background: "linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0))",
							}}
							onClick={(e) => {
								e.stopPropagation();
								navigator.clipboard.writeText(label);
								toast.success(intl.formatMessage({ id: "copied_to_clipboard"}, { text: label }));
							}}
						>
							<span
								className="text-white fw-bold p-1 rounded-2"
								style={{ backgroundColor: BRAND_COLOR, fontSize: 10 }}
							>
								<i className="fas fa-copy"></i> {label}
							</span>
						</div>
					) : null}
				</div>
			</div>
			{showModal && (
				<div
					className="modal fade show d-block"
					tabIndex={-1}
					role="dialog"
					onClick={() => setShowModal(false)}
					style={{
						backgroundColor: "rgba(0, 0, 0, 0.85)",
						position: "fixed",
						top: 0,
						left: 0,
						width: "100%",
						height: "100%",
						zIndex: 1050,
					}}
				>
					<div className="d-flex justify-content-center align-items-center h-100">
						<img
							src={src}
							alt="Full preview"
							className="img-fluid"
							style={{ maxHeight: "90%", maxWidth: "90%", cursor: "pointer" }}
							onClick={() => setShowModal(false)}
						/>
					</div>
				</div>
			)}
		</>
	);
}
